//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "account-detail",
  data(){
    return{
      title:null,
      supplierName:null,
      list:[],
      allLoaded:false,
      config:{
        url:'api/sup-account/page',
        title:'供应商账号详情',
        property: "id",
        fixRules:{}
      },
      wrapperHeight:0
    }
  },
  methods:{
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    dataInit(){
      if(this.$route.params.name){
        this.title = this.$route.params.name;
        this.config.title = this.$route.params.name;
        this.config.fixRules = {
          fixed: true,
          rules:[
            {
              collectIndex: -1,
              field: "supplier.supBasicInfo.supplierName-person.name-person.name-person.user.login",
              option: "LIKE_ANYWHERE",
              values:[this.title]
            }
          ]
        };
      }else{
        this.title = '我的账号';
        this.config.title = '我的账号';
      }
      setTimeout(() => {
        this.$refs.header.getlist();
      },200);
    }
  },
  mounted(){
    this.init();
    this.dataInit();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-account/account-detail.vue